export const EVENT = 'EVENT';
export const SET_FREEZE_EVENTS = 'SET_FREEZE_EVENTS';
export const STORE_EVENT = 'STORE_EVENT';
export const CLEAR_FROZEN_QUEUE = 'CLEAR_FROZEN_QUEUE';
